@if (options.backdrop) {
  <div (click)="onBackdropClick()" class="backdrop"></div>
}
<ng-template #modalContainer></ng-template>
